<div class="hero-bg hero-bg-contact">
    <app-navbar/>
    <div class="d-flex flex-column justify-content-center hero-header">
        <div class="app-container">
            <h1>{{ 'visitors.description' | translate }}</h1>
        </div>
    </div>
</div>
<div class="app-container pt-4" *ngIf="!checkedIn">
    <h2>{{ 'visitors.content-title' | translate }}</h2>
    <div class="col-lg-8">
        <div class="row mt-5">
            <div class="col-md-6">
                <label>{{ 'visitors.lastName'| translate }}:</label>
                <div class="form-group">
                    <input class="form-control" [(ngModel)]="model.lastName"
                           [disabled]="saving"
                           autocomplete="LastName"
                           [placeholder]="'visitors.lastName'| translate"/>
                </div>
            </div>
            <div class="col-md-6">
                <label>{{ 'visitors.firstName'| translate }}:</label>
                <div class="form-group">
                    <input class="form-control" [(ngModel)]="model.firstName"
                           [disabled]="saving"
                           autocomplete="FirstName"
                           [placeholder]="'visitors.firstName'| translate"/>
                </div>
            </div>
        </div>

        <label>{{ 'visitors.company'| translate }}:</label>
        <div class="form-group">
            <input class="form-control" [(ngModel)]="model.company"
                   [disabled]="saving"
                   autocomplete="Company"
                   [placeholder]="'visitors.company'| translate"/>
        </div>

        <label>{{ 'visitors.reasonForVisiting'| translate }}:</label>
        <div class="form-group">
            <input class="form-control" [(ngModel)]="model.reasonForVisiting"
                   [disabled]="saving"
                   autocomplete="visitors.reasonForVisiting"
                   [placeholder]="'visitors.reasonForVisiting'| translate"/>
        </div>

        <label>{{ 'visitors.contactPerson'| translate }}:</label>
        <div class="form-group">
            <input class="form-control" [(ngModel)]="model.contactPerson"
                   [disabled]="saving"
                   [placeholder]="'visitors.contactPerson'| translate"/>
        </div>

        <label>{{ 'visitors.idDetails'| translate }}:</label>
        <div class="form-group">
            <input class="form-control" [(ngModel)]="model.idDetails"
                   [disabled]="saving"
                   autocomplete="IdDetails"
                   [placeholder]="'visitors.idDetails'| translate"/>
        </div>

        <label>{{ 'visitors.cardAccess'| translate }}:</label>
        <div class="form-group">
            <input class="form-control" [(ngModel)]="model.cardAccess"
                   [disabled]="saving"
                   autocomplete="CardAccess"
                   [placeholder]="'visitors.cardAccess'| translate"/>
        </div>

        <app-form-check [value]="model.stayUntilDayEnd"
                        (valueChange)="changeStayUntilDayEnd($event)"
                        [label]="'visitors.stayUntilDayEnd'"
                        [falseLabel]="'visitors.stayUntilTime'"/>
        <div class="row">
            <div class="col-md-6">
                <label>{{ 'visitors.entryHour'| translate }}:</label>
                <app-datepicker [value]="model.entryHour"
                                (valueChange)="changeEntryHour($event)"
                                [disabled]="saving"
                                [placeholder]="'visitors.entryHour'"/>
            </div>
            <div class="col-md-6" *ngIf="!model.stayUntilDayEnd">
                <label>{{ 'visitors.exitHour'| translate }}:</label>
                <app-datepicker [(value)]="model.exitHour"
                                [disabled]="saving"
                                [placeholder]="'visitors.exitHour'"/>
            </div>
        </div>
        <div class="col-md-6">
            <app-sig-pad [(signature)]="model.signature"/>
        </div>
      <label class="form-check-label">
        {{ 'trailblazer_consent' |translate }}
        <a href="visitors/Final - Notice on processing of PII - Visitors.pdf" target="_blank">
          Privacy notice for visitor form
        </a>
      </label>
        <button (click)="submit()" [disabled]="saving || !isValid()"
                type="submit"
                class="call-to-action-link-btn news-button me-2 mt-2">
            <span>{{ 'visitors.submitForm' |translate }}</span>
        </button>
    </div>
</div>
<div class="app-container pt-4" *ngIf="checkedIn">
    <div class="alert alert-success">
        {{ 'visitors.checkedIn' |translate }}
    </div>
</div>
